import { Store } from "./store";

export type SvgRefStore = Store<NodeListOf<SVGElement>>;

export function setSvgSize(svg: SVGSVGElement): SVGSVGElement {
    const viewBox = svg.getAttribute("viewBox");
    if (viewBox) {
        const [_x, _y, width, height] = viewBox.split(" ").map(parseFloat);
        svg.setAttribute("width", width.toString());
        svg.setAttribute("height", height.toString());
    }
    return svg;
}

const ID_RE = /^(?<oid>.*)-\d+$/;

export async function processSvgInjection(
    svg: SVGSVGElement,
    svgRefStore: SvgRefStore,
    lookupRefs: Record<string, string>,
    textAnchorRight: string[] = [],
    refPrefix = "",
): Promise<void> {
    // trying to restorer original ids of elements,
    // after SVGInject and Affinity Designer mangle them up
    const els = svg.getElementsByTagName("*");
    for (const el of Array.from(els)) {
        let oid = el.id;
        const search = ID_RE.exec(oid);
        if (search?.length) {
            oid = search.groups?.oid ?? oid;
        }
        if (el.hasAttribute("serif:id")) {
            oid = el.getAttribute("serif:id")!;
        }
        if (oid) {
            el.setAttribute("oid", oid);
        }
    }

    await document.fonts.ready;

    for (const selector of textAnchorRight) {
        const el = svg.querySelector<SVGTextElement>(selector)!;
        el.setAttribute("x", (el.getBBox().x + el.getComputedTextLength()).toString() + "px");
        el.setAttribute("text-anchor", "end");
    }

    for (const [refKey, selector] of Object.entries(lookupRefs)) {
        const nodes = svg.querySelectorAll<SVGElement>(selector)!;
        if (!nodes.length) {
            // eslint-disable-next-line no-console
            console.warn(`no nodes found for ${refKey}: ${selector}`);
        }
        svgRefStore.set(refPrefix + refKey, nodes);
    }
}
